import queryString from 'query-string';
import { apiGET } from './api';

export const getEnvironmentImpact = (params) => { 
  const query = queryString.stringify(params);
  
  return apiGET(`/environment_impact?${query}`);
};
